import initialState from 'ub/fonts/font-picker/button/initial-state';

const NORMAL_WEIGHT = 400;

const renderInitialState = () => {
  return initialState;
};

const updateButtonStyles = (currentState, value, modelData) => {
  if (!modelData) {
    return currentState;
  }

  const family = modelData.safeGet('style.fontFamily') || initialState.family;
  const size = parseInt(modelData.safeGet('style.fontSize'), 10) || initialState.size;
  const style = modelData.safeGet('style.fontStyle') || initialState.style;
  let textStyles = modelData.safeGet('style.textStyles') || initialState.textStyles;
  let weight = modelData.safeGet('style.fontWeight') || NORMAL_WEIGHT;

  // This is to normalize the old font-weight data
  if (weight === 'normal') {
    modelData.set('style.fontWeight', NORMAL_WEIGHT);

    weight = NORMAL_WEIGHT;

  } else if (weight === 'bold') {
    modelData.set('style.textStyles.strong', true);
    modelData.set('style.fontWeight', NORMAL_WEIGHT);

    weight = NORMAL_WEIGHT;

    textStyles = {
      ...textStyles,
      strong: true
    };
  }

  return {
    ...currentState,
    family,
    weight,
    size,
    style,
    textStyles
  };
};

const fontChange = (currentState, {family, weight, style}, modelData) => {
  modelData.set('style.fontFamily', family);
  modelData.set('style.fontWeight', weight);
  modelData.set('style.fontStyle', style);

  return {
    ...currentState,
    family,
    weight,
    style
  };
};

const fontSizeChange = (currentState, size, modelData) => {
  modelData.set('style.fontSize', size);

  return {
    ...currentState,
    size
  };
};

const styleChange = (currentState, styleName, modelData) => {
  const newValue = !currentState.textStyles[styleName];

  modelData.set(`style.textStyles.${styleName}`, newValue);

  return {
    ...currentState,
    textStyles: {
      ...currentState.textStyles,
      [styleName]: newValue,
    }
  };
};

const removeFont = (currentState) => {
  return {...currentState};
};

export default {
  renderInitialState,
  updateButtonStyles,
  fontChange,
  fontSizeChange,
  styleChange,
  removeFont
};



// WEBPACK FOOTER //
// ./src/fonts/font-picker/button/font-actions.js